var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Fragment',[_c('img',{staticClass:"blue_bg",attrs:{"alt":"","src":_vm.img}}),_c('div',{staticClass:"info"},[_c('h3',[_c('span',[_vm._v(" "+_vm._s(_vm.title)+" ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }